import { render, staticRenderFns } from "./ViewPricing.vue?vue&type=template&id=1159b0c8&scoped=true&"
import script from "./ViewPricing.vue?vue&type=script&lang=js&"
export * from "./ViewPricing.vue?vue&type=script&lang=js&"
import style0 from "./ViewPricing.vue?vue&type=style&index=0&id=1159b0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1159b0c8",
  null
  
)

export default component.exports